import { Component, OnInit } from '@angular/core';
import { BoatService } from '../services/boat.service';
import { Router } from '@angular/router';
import { getBoatImageUrl } from '../utils/image-url.util';

@Component({
  selector: 'app-featop',
  templateUrl: './featop.component.html',
  styleUrls: ['./featop.component.css']
})
export class FeatopComponent implements OnInit {
  kapalList: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  tripKategori: string = 'Open Trip Komodo National Park';

  kapalLoaded: { [id: number]: boolean } = {};

  constructor(private boatService: BoatService, private router: Router) {}

  getImageUrl(path: string): string {
    return getBoatImageUrl(path);
  }

  ngOnInit(): void {
    this.fetchKapal();
  }

fetchKapal(): void {
  this.boatService.getFeat(this.tripKategori, this.currentPage)
    .subscribe(response => {
      if (response.success) {
        this.kapalList = response.items.map((boat: any) => {
          if (boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0) {
            boat.ms_gambarkapals = boat.ms_gambarkapals.map((img: any, index: number) => ({
              ...img,
              loaded: index === 0 // hanya preload gambar pertama
            }));
          }
          return boat;
        });
        this.totalPages = response.totalPages;
      }
    }, error => {
      console.error('Error fetching data:', error);
    });
}


  navigateToDetail(slug: string): void {
    this.router.navigate(['/detail-boatopen', slug]);
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.fetchKapal();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.fetchKapal();
    }
  }

onCarouselSlid(event: any, boat: any): void {
  const items = event.target.querySelectorAll('.carousel-item');
  const activeIndex = Array.from(items).findIndex((item: any) =>
    item.classList.contains('active')
  );

  if (
    boat.ms_gambarkapals &&
    boat.ms_gambarkapals[activeIndex] &&
    !boat.ms_gambarkapals[activeIndex].loaded
  ) {
    boat.ms_gambarkapals[activeIndex].loaded = true;
  }
}


}
